import React from 'react';
import { Card, CardContent } from '../../../components/ui/card';

const SetupGuideSection = () => {
  return (
    <Card>
      <CardContent className="p-6">
        <h3 className="text-lg font-semibold text-gray-900 mb-4">Integration Example</h3>
        <div className="space-y-6">
          <div>
            <h4 className="font-medium text-gray-900 mb-2">Node.js</h4>
            <div className="bg-gray-50 p-4 rounded-lg overflow-x-auto">
              <pre className="text-sm text-gray-800">
{`const response = await fetch('https://api.deltaops.app/api/deltaops/changelog/', {
  method: 'POST',
  headers: {
    'Authorization': 'Bearer YOUR_API_KEY',
    'Content-Type': 'application/json',
  },
  body: JSON.stringify({
    title: 'Deployed v1.2.3',
    description: 'Released new features including...',
    tags: ['deployment', 'feature-release'],
    severity: 'low'
  })
});

const data = await response.json();
console.log(data);`}
              </pre>
            </div>
          </div>

          <div>
            <h4 className="font-medium text-gray-900 mb-2">Python</h4>
            <div className="bg-gray-50 p-4 rounded-lg overflow-x-auto">
              <pre className="text-sm text-gray-800">
{`import requests

response = requests.post(
    'https://api.deltaops.app/api/deltaops/changelog/',
    headers={
        'Authorization': 'Bearer YOUR_API_KEY',
        'Content-Type': 'application/json'
    },
    json={
        'title': 'Deployed v1.2.3',
        'description': 'Released new features including...',
        'tags': ['deployment', 'feature-release'],
        'severity': 'low'
    }
)

data = response.json()
print(data)`}
              </pre>
            </div>
          </div>

          <div>
            <h4 className="font-medium text-gray-900 mb-2">cURL</h4>
            <div className="bg-gray-50 p-4 rounded-lg overflow-x-auto">
              <pre className="text-sm text-gray-800">
{`curl -X POST https://api.deltaops.app/api/deltaops/changelog/ \\
  -H "Authorization: Bearer YOUR_API_KEY" \\
  -H "Content-Type: application/json" \\
  -d '{
    "title": "Deployed v1.2.3",
    "description": "Released new features including...",
    "tags": ["deployment", "feature-release"],
    "severity": "low"
  }'`}
              </pre>
            </div>
          </div>
        </div>
      </CardContent>
    </Card>
  );
};

export default SetupGuideSection;